import React, { useContext, useEffect, useMemo, useState } from 'react';
import { TagsSearchInput, TagsSearchInputWrapper, TagsSearchModalContainer, TagsSearchModalWrapper, TagsSearchTitle, CardsWrapper, CardsEmptyTitle, CardsEmptySubTitle, CardsEmptyButtonWrapper, CardsEmptyButtonHollow, CardsEmptyButtonFilled, NoProjectWrapper } from './styles';
import { useTheme } from 'styled-components';
import urlApi from '../../../actions/urlApi';
import { API } from '@brg/api';
import queryString from 'query-string';
import { CountryViewCard } from '../../cards/CountryViewCard';
import LangContext from '../../../contexts/Language/LangContext';
import { modalControllerActions } from '../../../core/modules/modal.module';
import { useDispatch } from 'react-redux';
import { getGalllleryUrl } from '../../../actions/getGalllleryUrl';
import Masonry from "react-masonry-css";
import { useIsMobile } from "@brg/ui";
import SearchIcon16 from '../../icons/SearchIcon16';
import useCommonProps from '../../../hooks/useCommonProps';
export var debounceEvent = function (callback, time) {
    var interval;
    // @ts-ignore
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(interval);
        interval = setTimeout(function () {
            interval = null;
            // eslint-disable-next-line standard/no-callback-literal
            callback.apply(void 0, args);
        }, time);
    };
};
export var useGetUserCollectionCards = function (queryString) {
    var _a = useState(null), data = _a[0], setData = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        if (queryString) {
            setLoading(true);
            urlApi()
                .getUserCollectionCards(queryString)
                .then(function (r) {
                setData(r);
            })
                .finally(function () { return setLoading(false); });
        }
    }, [queryString]);
    return { data: data, loading: loading };
};
var CardSelectModal = function (_a) {
    var onCardSelect = _a.onCardSelect, themeColor = _a.themeColor;
    var theme = useTheme();
    var _b = useState(''), search = _b[0], setSearch = _b[1];
    var dispatch = useDispatch();
    var isMobile = useIsMobile();
    var isWhite = useMemo(function () { return themeColor === 'light'; }, [themeColor]);
    // @ts-ignore
    var t = useContext(LangContext).t;
    var authorId = useCommonProps().authorId;
    var cardsQueryString = useMemo(function () {
        // @ts-ignore
        return queryString.stringify({
            cardOnlyImage: true,
            status: [2],
            userIds: [authorId],
            search: search,
            isHeaderIgnored: true,
            isLite: 'true',
            limit: 50
        });
    }, [search]);
    var _c = useGetUserCollectionCards(cardsQueryString), data = _c.data, loading = _c.loading;
    // @ts-ignore
    var cards = API.lang(data === null || data === void 0 ? void 0 : data.data, 'en');
    var onInputText = function (e) {
        var text = e.target.value.trim();
        setSearch(text);
    };
    if (!loading && (cards === null || cards === void 0 ? void 0 : cards.length) === 0 && !search)
        return (React.createElement(TagsSearchModalWrapper, { scroll: true, isWhite: true },
            React.createElement(TagsSearchModalContainer, { isCenterModal: true },
                React.createElement(CardsEmptyTitle, null, t('modal.select_card_modal.no_cards')),
                React.createElement(CardsEmptySubTitle, null, t('modal.select_card_modal.no_cards_desc')),
                React.createElement(CardsEmptyButtonWrapper, null,
                    React.createElement(CardsEmptyButtonHollow, { onClick: function () { return dispatch(modalControllerActions.hideModal({})); } }, t('modal.select_card_modal.continue_edit')),
                    React.createElement(CardsEmptyButtonFilled, { onClick: function () { return window.open(getGalllleryUrl(), '_blank'); } }, t('modal.select_card_modal.go_to_gallllery'))))));
    return (React.createElement(TagsSearchModalWrapper, { scroll: true, isWhite: isWhite },
        React.createElement(TagsSearchModalContainer, null,
            React.createElement(TagsSearchTitle, { isWhite: isWhite }, t('modal.select_card_modal.select_card')),
            React.createElement(TagsSearchInputWrapper, { isWhite: isWhite, offsetTop: 68, offsetBottom: 24 },
                React.createElement(SearchIcon16, { fill: theme.tags.modal.search.color }),
                React.createElement(TagsSearchInput, { isWhite: isWhite, onInput: debounceEvent(onInputText, 500), autoFocus: true, placeholder: t('modal.select_card_modal.search_card') })),
            (cards === null || cards === void 0 ? void 0 : cards.length) > 0 ? React.createElement(CardsWrapper, null,
                React.createElement(Masonry, { breakpointCols: isMobile ? 2 : 4, className: "main-page-masonry-grid", columnClassName: "main-page-masonry-grid_column" }, !!data &&
                    (
                    /* @ts-ignore */
                    cards === null || cards === void 0 ? void 0 : cards.map(function (museumCard) { return (React.createElement(React.Fragment, null,
                        React.createElement(CountryViewCard, { key: museumCard.cardId, cardId: museumCard.cardId, museumCard: museumCard, onClickHandler: onCardSelect, borderless: true }))); })))) : React.createElement(NoProjectWrapper, null, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E :("))));
};
export default CardSelectModal;
//# sourceMappingURL=CardSelectModal.js.mapimport React, { useContext, useEffect, useMemo, useState } from 'react';
import { TagsSearchInput, TagsSearchInputWrapper, TagsSearchModalContainer, TagsSearchModalWrapper, TagsSearchTitle, CardsWrapper, CardsEmptyTitle, CardsEmptySubTitle, CardsEmptyButtonWrapper, CardsEmptyButtonHollow, CardsEmptyButtonFilled, NoProjectWrapper } from './styles';
import { useTheme } from 'styled-components';
import urlApi from '../../../actions/urlApi';
import { API } from '@brg/api';
import queryString from 'query-string';
import { CountryViewCard } from '../../cards/CountryViewCard';
import LangContext from '../../../contexts/Language/LangContext';
import { modalControllerActions } from '../../../core/modules/modal.module';
import { useDispatch } from 'react-redux';
import { getGalllleryUrl } from '../../../actions/getGalllleryUrl';
import Masonry from "react-masonry-css";
import { useIsMobile } from "@brg/ui";
import SearchIcon16 from '../../icons/SearchIcon16';
import useCommonProps from '../../../hooks/useCommonProps';
export var debounceEvent = function (callback, time) {
    var interval;
    // @ts-ignore
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(interval);
        interval = setTimeout(function () {
            interval = null;
            // eslint-disable-next-line standard/no-callback-literal
            callback.apply(void 0, args);
        }, time);
    };
};
export var useGetUserCollectionCards = function (queryString) {
    var _a = useState(null), data = _a[0], setData = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        if (queryString) {
            setLoading(true);
            urlApi()
                .getUserCollectionCards(queryString)
                .then(function (r) {
                setData(r);
            })
                .finally(function () { return setLoading(false); });
        }
    }, [queryString]);
    return { data: data, loading: loading };
};
var CardSelectModal = function (_a) {
    var onCardSelect = _a.onCardSelect, themeColor = _a.themeColor;
    var theme = useTheme();
    var _b = useState(''), search = _b[0], setSearch = _b[1];
    var dispatch = useDispatch();
    var isMobile = useIsMobile();
    var isWhite = useMemo(function () { return themeColor === 'light'; }, [themeColor]);
    // @ts-ignore
    var t = useContext(LangContext).t;
    var authorId = useCommonProps().authorId;
    var cardsQueryString = useMemo(function () {
        // @ts-ignore
        return queryString.stringify({
            cardOnlyImage: true,
            status: [2],
            userIds: [authorId],
            search: search,
            isHeaderIgnored: true,
            isLite: 'true',
            limit: 50
        });
    }, [search]);
    var _c = useGetUserCollectionCards(cardsQueryString), data = _c.data, loading = _c.loading;
    // @ts-ignore
    var cards = API.lang(data === null || data === void 0 ? void 0 : data.data, 'en');
    var onInputText = function (e) {
        var text = e.target.value.trim();
        setSearch(text);
    };
    if (!loading && (cards === null || cards === void 0 ? void 0 : cards.length) === 0 && !search)
        return (React.createElement(TagsSearchModalWrapper, { scroll: true, isWhite: true },
            React.createElement(TagsSearchModalContainer, { isCenterModal: true },
                React.createElement(CardsEmptyTitle, null, t('modal.select_card_modal.no_cards')),
                React.createElement(CardsEmptySubTitle, null, t('modal.select_card_modal.no_cards_desc')),
                React.createElement(CardsEmptyButtonWrapper, null,
                    React.createElement(CardsEmptyButtonHollow, { onClick: function () { return dispatch(modalControllerActions.hideModal({})); } }, t('modal.select_card_modal.continue_edit')),
                    React.createElement(CardsEmptyButtonFilled, { onClick: function () { return window.open(getGalllleryUrl(), '_blank'); } }, t('modal.select_card_modal.go_to_gallllery'))))));
    return (React.createElement(TagsSearchModalWrapper, { scroll: true, isWhite: isWhite },
        React.createElement(TagsSearchModalContainer, null,
            React.createElement(TagsSearchTitle, { isWhite: isWhite }, t('modal.select_card_modal.select_card')),
            React.createElement(TagsSearchInputWrapper, { isWhite: isWhite, offsetTop: 68, offsetBottom: 24 },
                React.createElement(SearchIcon16, { fill: theme.tags.modal.search.color }),
                React.createElement(TagsSearchInput, { isWhite: isWhite, onInput: debounceEvent(onInputText, 500), autoFocus: true, placeholder: t('modal.select_card_modal.search_card') })),
            (cards === null || cards === void 0 ? void 0 : cards.length) > 0 ? React.createElement(CardsWrapper, null,
                React.createElement(Masonry, { breakpointCols: isMobile ? 2 : 4, className: "main-page-masonry-grid", columnClassName: "main-page-masonry-grid_column" }, !!data &&
                    (
                    /* @ts-ignore */
                    cards === null || cards === void 0 ? void 0 : cards.map(function (museumCard) { return (React.createElement(React.Fragment, null,
                        React.createElement(CountryViewCard, { key: museumCard.cardId, cardId: museumCard.cardId, museumCard: museumCard, onClickHandler: onCardSelect, borderless: true }))); })))) : React.createElement(NoProjectWrapper, null, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E :("))));
};
export default CardSelectModal;
//# sourceMappingURL=CardSelectModal.js.map